import axiosInstance from "./AxiosInstance"

export function getPatientGapld(patient_id) {
  return axiosInstance.post(
    "/patient/GAPLDList",
    {
      patient_id: patient_id,
    
    },
   
  )
}

// Fetch marriage info for a patient
export function getPatientMarriageInfo(patient_id) {
  return axiosInstance.post("/patient/getPatientMarriageInfo", { patient_id })
} 

export function createPatientGapld(data) {
  return axiosInstance.post("/patient/addGAPLD", data)
}

export function updatePatientGapld(data) {
  return axiosInstance.post("/patient/editGAPLD", data)
}

export function deletePatientGapld(entry) {
  return axiosInstance.post("/patient/deleteGAPLD", {
    gapld_id: entry.gapld_id,
  })
}

export function formatPatientGapld(responseData) {
  if (!responseData || !Array.isArray(responseData)) return []

  return responseData.map((entry) => ({
    gapld_id: entry.gapld_id,
    patient_id: entry.patient_id,

    pregnancy_status: entry.pregnancy_status || "",
    marriage_info_id: entry.marriage_info_id || "",

    delivery_date: entry.delivery_date || "0000-00-00",
    abortion_date: entry.abortion_date || "0000-00-00",
    pregnancy_month: entry.pregnancy_month || "",

    How_was_the_delivery: entry.How_was_the_delivery || "",
    gender: entry.gender || "",
    which_rx_helped: entry.which_rx_helped || "",

    // 🔽 L / D / D+ related fields
    child_born_alive: entry.child_born_alive || "",
    death_within_28_days: entry.death_within_28_days || "",
    death_after_28_days: entry.death_after_28_days || "",
    currently_alive: entry.currently_alive || "",
    death_timing: entry.death_timing || "",

    // 🔽 Abortion / Miscarriage details
    how_did_miscarriage_happen: entry.how_did_miscarriage_happen || "",
    miscarriage_reason: entry.miscarriage_reason || "",

    // meta
    gapld_status: entry.gapld_status || "Active",
    created_by: entry.created_by || "",
    created_at: entry.created_at || "",
    updated_at: entry.updated_at || "",
    marriage_history: entry.marriage_history || "",
    by_patient: entry.by_patient || "",
  }))
}

